import { IFieldMetaData } from "./IField"
import { comparisionValues } from "./IValidationRule"

export interface IDuTypeFormField {
  containerType: IFieldMetaData
  containerName: IFieldMetaData
  description: IFieldMetaData
  // legacyContainerType: IFieldMetaData
  // legacyContainerName: IFieldMetaData
  // legacyDescription: IFieldMetaData
  //customerType: IFieldMetaData
  weight: IFieldMetaData
  volume: IFieldMetaData
  fullLength: IFieldMetaData
  fullWidth: IFieldMetaData
  fullHeight: IFieldMetaData
  weightCap: IFieldMetaData
  minPickVolume: IFieldMetaData
  maxPickVolume: IFieldMetaData
  lpIndicator: IFieldMetaData
  mlpIndicator: IFieldMetaData
  muIndicator: IFieldMetaData
  isLinkableContainer: IFieldMetaData
  legacyContainerHasValue: IFieldMetaData
}

export const FIELDS: IDuTypeFormField = {
  containerType: { name: "containerType", rules: { required: {}, alphanumeric: {} } },
  containerName: { name: "containerName", rules: { required: {}, alphanumeric: {} } },
  description: { name: "description", rules: { required: {} } },
  // legacyContainerType: { name: "legacyContainerType", rules: { alphanumeric: {} } },
  // legacyContainerName: { name: "legacyContainerName", rules: { alphanumeric: {} } },
  // legacyDescription: { name: "legacyDescription", rules: { alphanumeric: {} } },
  //legacyContainers: { name: "legacyContainers", rules: { alphanumeric: {} } },
  //customerType: { name: "customerType", rules: { } },
  weight: { name: "weight", rules: { required: {}, decimal: {}, inputRange: { comparision: "greater", lowerLimit: 0 } } },
  volume: { name: "volume", rules: { required: {}, decimal: {}, inputRange: { comparision: "greater", lowerLimit: 0 } } },
  fullLength: { name: "fullLength", rules: { required: {}, decimal: {}, inputRange: { comparision: "greater", lowerLimit: 0 } } },
  fullWidth: { name: "fullWidth", rules: { required: {}, decimal: {}, inputRange: { comparision: "greater", lowerLimit: 0 } } },
  fullHeight: { name: "fullHeight", rules: { required: {}, decimal: {}, inputRange: { comparision: "greater", lowerLimit: 0 } } },
  weightCap: { name: "weightCap", rules: { required: {}, decimal: {}, inputRange: { comparision: "greater", lowerLimit: 0 } } },
  minPickVolume: { name: "minPickVolume", rules: { required: {}, decimal: {}, inputRange: { comparision: "greaterOrEqual", lowerLimit: 0 }, custom: {} } },
  maxPickVolume: { name: "maxPickVolume", rules: { required: {}, decimal: {}, inputRange: { comparision: "greater", lowerLimit: 0 }, custom: {} } },
  lpIndicator: { name: "lpIndicator", rules: {} },
  mlpIndicator: { name: "mlpIndicator", rules: { custom: {} } },
  muIndicator: { name: "muIndicator", rules: {} },
  isLinkableContainer: { name: "isLinkableContainer", rules: { custom: {} } },
  legacyContainerHasValue: { name: "legacyContainerHasValue", rules: { custom: {} } },
}

export const ERROR_MESSAGES = {
  required: "This field is required",
  decimal: "This field only takes decimal values",
  alphanumeric: "This field only takes alphanumeric values",
  integer: (value: string | number) =>
    `Entered value (e.g. ‘${value}’) is not an integer.`,
  inputRange: (
    lowerLimit: number | undefined,
    upperLimit: number | undefined,
    unit: string | undefined = "",
    comparision?: comparisionValues
  ) => {

    switch (comparision) {
      case "greater":
        {
          return `Value must be greater than ${lowerLimit}${unit}`;
        }
      case "greaterOrEqual":
        {
          return `Value must be greater than or equal to ${lowerLimit}${unit}`;
        }
      default:
        {
          return `Value must be greater than or equal to ${lowerLimit}${unit} and less than or equal to ${upperLimit}${unit}`;
        }
    }
  },
  isLinkable: "Container is linked with other containers",
  mlpIndicator: "MLP is selected, at least one container should be linked",
  legacyContainerHasValue: "At least one leagcy container should be linked",
}

export enum FormInputLevels {
  CONTAINERTYPE = "Container Type",
  CONTAINERTNAME = "Container Name",
  DESCRIPTION = "Description",
  LEGACYCONTAINERTYPE = "Container Type",
  LEGACYCONTAINERTNAME = "Container Name",
  LEGACYDESCRIPTION = "Container Description",
  LinkedContainerType = "Linked Container Type",
  LinkedContainerQuantity = "Quantity",
  CUSTOMERTYPE = "Customer Type",
  WEIGHT = "Weight (KG)",
  VOLUME = "Volume",
  FULLLENGTH = "Full Length (CM)",
  FULLWIDTH = "Full Width (CM)",
  FULLHEIGHT = "Full Height (CM)",
  WEIGTHCAP = "Weight Cap (KG)",
  MINPICKVOLUME = "Min Pick Volume",
  MAXPICKVOLUME = "Max Pick Volume",
  LPINDICATOR = "LP Indicator",
  MLPINDICATOR = "MLP Indicator",
  MUINDICATOR = "MU Indicator",
  ISLINKABLECONTAINER = "Is Linkable"
}

export interface IDuTypeError {
  containerType: string | undefined
  containerName: string | undefined
  description: string | undefined
  // legacyContainerType: string | undefined
  // legacyContainerName: string | undefined
  // legacyDescription: string | undefined
  //customerType: string | undefined
  weight: string | undefined
  volume: string | undefined
  fullLength: string | undefined
  fullWidth: string | undefined
  fullHeight: string | undefined
  weightCap: string | undefined
  minPickVolume: string | undefined
  maxPickVolume: string | undefined
  lpIndicator: string | undefined
  mlpIndicator: string | undefined
  muIndicator: string | undefined
  isLinkableContainer: string | undefined
  legacyContainerHasValue: string | undefined
}
